import { IImageProps, Image } from 'native-base';
import React from 'react';

export function HeyFellaBadge({ w, h }: Pick<IImageProps, 'w' | 'h'>) {
  return (
    <Image source={require('./heyfellabadge.png')} w={w ?? 20} h={h ?? 20} resizeMode={'contain'} />
  );
}
